module.exports = "<ng-container *ngComponentOutlet=\"dynamicComponent; ngModuleFactory: dynamicModule;\"></ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/app/stage/components/dynamic/dynamic.component.html
// module id = ./src/app/stage/components/dynamic/dynamic.component.html
// module chunks = main